import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CareerPlanResource } from 'src/app/models/career-plans';
import { LocaleService } from 'src/app/services/locale.service';
import { Util } from 'src/app/util';

@Component({
  selector: 'app-resource-card',
  templateUrl: './resource-card.component.html',
  styleUrls: ['./resource-card.component.scss'],
})
export class ResourceCardComponent implements OnInit {
  @Input()
  resource: CareerPlanResource;

  coverUrl: string;

  completionLabel: string;

  constructor(
    private router: Router,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.resolveCompletionLabel();
    this.coverUrl = this.resource.coverUrl == null ? 'assets/cover.jpg' : this.resource.coverUrl;
  }

  navigateToResource() {
    this.router.navigate(['/info', Util.slugify(this.resource.title) + '-' + this.resource.recordId]);
  }

  private resolveCompletionLabel() {
    this.completionLabel =
      this.resource.progress >= 85
        ? this.localeService.instant('user.careerplans.status.completed')
        : this.localeService.instant('user.careerplans.status.checking');
  }
}
